import { Stack, Typography, styled } from "@mui/material";
import { FC } from "react";

const TypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

interface MainContentHeaderProps {
  title: string;
  subTitle?: string;
  actions?: React.ReactNode;
}

export const MainContentHeader: FC<MainContentHeaderProps> = ({
  title,
  subTitle,
  actions,
}) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap={4}
      sx={{
        position: "sticky",
        top: 60,
        zIndex: 1,
        backgroundColor: "background.paper",
        paddingBlock: 2,
        borderBottom: "1px solid",
        borderColor: "neutral.100",
      }}
    >
      <Stack spacing={1}>
        <TypographyStyled
          variant="h4"
          sx={{
            fontSize: {
              xs: "1.2rem",
              md: "2rem",
            },
          }}
        >
          {title}
        </TypographyStyled>
        <Typography
          sx={{
            color: "neutral.500",
          }}
          variant="body2"
          gutterBottom
        >
          {subTitle}
        </Typography>
      </Stack>
      <Stack alignItems="center" direction="row" gap={3}>
        {actions}
      </Stack>
    </Stack>
  );
};
